import React from 'react';
import { Link } from 'react-router-dom';
import { trackJoinDiscord } from '../lib/analytics';

const Footer = () => {
  return (
    <footer className="bg-hvy-900 text-gray-400">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {/* Logo & tagline */}
          <div className="flex flex-col items-center md:items-start">
            <img src="/logo.webp" alt="JTF Heavy" className="h-12 mb-3" />
            <p className="text-sm text-gray-500">
              Global DCS combat aviation community.
            </p>
          </div>

          {/* Navigation */}
          <div className="flex flex-col items-center">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-gray-300 mb-3">Navigate</h4>
            <nav className="flex flex-col items-center space-y-2">
              <a href="/#about-us" className="text-sm hover:text-white transition-colors">About Us</a>
              <a href="/#how-to-join" className="text-sm hover:text-white transition-colors">How to Join</a>
              <a href="/#squadrons" className="text-sm hover:text-white transition-colors">Squadrons</a>
              <a href="/#join-discord" className="text-sm hover:text-white transition-colors">Discord</a>
              <Link to="/join-dcs-squadron" className="text-sm hover:text-white transition-colors">How to Join a DCS Squadron</Link>
              <Link to="/squadrons" className="text-sm hover:text-white transition-colors">Our DCS Squadrons</Link>
              <Link to="/watch" className="text-sm hover:text-white transition-colors">Watch Us Fly</Link>
            </nav>
          </div>

          {/* External links */}
          <div className="flex flex-col items-center md:items-end">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-gray-300 mb-3">External</h4>
            <nav className="flex flex-col items-center md:items-end space-y-2">
              <a
                href="https://perscom.jointtaskforceheavy.com"
                className="text-sm hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                PERSCOM
              </a>
              <a
                href="https://discord.gg/sPavY3ZZQH"
                className="text-sm hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackJoinDiscord('footer')}
              >
                Discord Server
              </a>
            </nav>
            {/* Social icons */}
            <div className="flex items-center gap-4 mt-4">
              <a href="https://www.youtube.com/@jointtaskforceheavy" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-red-500 transition-colors" aria-label="YouTube">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
              </a>
              <a href="https://www.facebook.com/jointtaskforceheavy/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-500 transition-colors" aria-label="Facebook">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="https://www.instagram.com/jointtaskforceheavy/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-pink-500 transition-colors" aria-label="Instagram">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
              </a>
            </div>
          </div>
        </div>

        {/* Divider + copyright */}
        <div className="mt-10 pt-6 border-t border-hvy-700/50 text-center">
          <p className="text-sm text-gray-500">&copy; {new Date().getFullYear()} Joint Task Force Heavy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
